<template>
	<el-dialog title="提示" :visible.sync="visible" :before-close="beforeClose" width="400px">
		<p>
			<i class="el-icon-info yx-color-warning fz-16"></i>
			<span class="yx-color-pure-1 ml-6 font-h4-regular">如需导出样品订单，请在“样品订单管理”中导出样品订单！</span>
		</p>
		<div slot="footer" class="footer-dialog">
			<el-button @click="visible = false">取 消</el-button>
			<el-button type="primary" @click="confirm">确认导出</el-button>
		</div>
	</el-dialog>
</template>
<script>
export default {
	data() {
		return {
			visible: false,
		};
	},
	methods: {
    show() {
      this.visible = true
    },
		beforeClose() {
			this.visible = false;
		},
		async confirm() {
      this.$emit('exportTable')
      this.beforeClose()
    },
	},
};
</script>
